import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const isAuthenticated = () => {
    return !!localStorage.getItem('token');
};

const getAllowedPaths = () => {
    try {
        const roleString = localStorage.getItem('role');
        if (!roleString) return [];
        const roles = JSON.parse(roleString);
        let paths = [];
        roles.forEach(item => {
            if (item.path) paths.push(item.path);
            if (item.subModules && Array.isArray(item.subModules)) {
                item.subModules.forEach(sub => {
                    if (sub.path) paths.push(sub.path);
                });
            }
        });
        return paths;
    } catch {
        return [];
    }
};

const ProtectedRoute = ({ children }) => {
    const location = useLocation();

    // Not logged in at all → go to login
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    const allowedPaths = getAllowedPaths();

    // Logged in but no role restrictions defined → allow through
    // (admin/superuser case where role array may be empty)
    if (allowedPaths.length === 0) {
        return children;
    }

    // Logged in but this path not in their role → not authorized
    if (!allowedPaths.includes(location.pathname)) {
        return <Navigate to="/not-authorized" replace />;
    }

    return children;
};

export default ProtectedRoute;
